<div class="flex items-center gap-x-[16px]">
  @if (user.username) {
    <span class="heading-14">{{ user.username }}</span>
  }

  @if (user.imageURL) {
    <lib-avatar [src]="user.imageURL" [alt]="user.username" />
  }
  @else {
    <lib-default-profile-icon></lib-default-profile-icon>
  }
  <div>
    <button class="h-[24px] w-[24px] border-blue-gray-300 border-[1px] flex items-center
      justify-center rounded-[4px]" (click)="toggleOptions()">
      <lib-chevron-down-icon [class]="{'rotate-180' : showOptions}" /> 
    </button>

    @if (showOptions) {
    <lib-user-panel [dropdownItems]="menuItems" [user]="user"></lib-user-panel>
    }
  </div>
</div>
